<template>
    <div class="wrapper wrapper-content">
        <div class="row">
            <div class="ibox float-e-margins">
                <div class="ibox-content">
                    <div class="row">
                        <div class="col-sm-10 m-b-xs">
                            <el-form :label-position="labelPosition" label-width="80px" :model="form">
                                <el-form-item label="文章标题">
                                    <el-input v-model="form.title"></el-input>
                                </el-form-item>
                                <el-form-item label="文章类型">
                                    <el-select v-model="form.category_id" placeholder="请选择">
                                        <el-option
                                                v-for="item in options"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="文章图片">
                                    <el-upload
                                            class="avatar-uploader"
                                            action="/api/file/upload"
                                            name="imageFiles"
                                            :data="uploadParams"
                                            :show-file-list="false"
                                            :on-success="uploadImage">
                                        <img v-if="form.image" :src="form.image" class="avatar">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </el-form-item>
                                <el-form-item label="缩略图">
                                    <el-upload
                                            class="avatar-uploader"
                                            action="/api/file/upload"
                                            name="imageFiles"
                                            :data="uploadParams"
                                            :show-file-list="false"
                                            :on-success="uploadThumbImage">
                                        <img v-if="form.thumb_image" :src="form.thumb_image" class="avatar">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                    </el-upload>
                                </el-form-item>
                                <el-form-item label="文章内容">
                                    <!--<el-input v-model="form.content"></el-input>-->
                                    <quill-editor v-model="form.content"
                                                  ref="myQuillEditor"
                                                  :options="editorOption"
                                                  :data="uploadParams"
                                                  @blur="onEditorBlur($event)"
                                                  @focus="onEditorFocus($event)"
                                                  @ready="onEditorReady($event)">
                                    </quill-editor>
                                </el-form-item>
                                <el-form-item v-if="id">
                                    <el-button type="primary" @click="onUpdate">确认修改</el-button>
                                </el-form-item>
                                <el-form-item v-else>
                                    <el-button type="primary" @click="onSubmit">立即创建</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { articleList ,creatArticle, detailArticle, updateArticle} from '@/services/article';
  import { categoryList } from '@/services/category'

  import qs from 'qs';
  import {quillEditor, Quill} from 'vue-quill-editor';
  import { ImageUpload } from 'quill-image-upload';
  Quill.register('modules/imageUpload', ImageUpload);

  export default {
    name: 'CreatArticlePage',
    computed: {
      editor() {
        return this.$refs.myQuillEditor.quill
      }
    },
    data() {
      return {
        options:[],
        id:this.$route.params.id,
        token:localStorage.getItem('token'),
        action:'' ,
        labelPosition: 'left',
        uploadParams: {
          type: 'image',
          app_id: '06bd61dd4e38b6bb',
          domain_type : 1 ,
          token:localStorage.getItem('token')
        },
        form: {
          title: '',
          thumb_image: '',
          image: '',
          category_id: [],
          content: ''
        },
        editorOption:{
          modules:{
            imageUpload: {
              url: '/file/upload/?' + qs.stringify({
                type: 'image',
                app_id: '06bd61dd4e38b6bb',
                domain_type : 1 ,
                token:localStorage.getItem('token')
              }), // server url. If the url is empty then the base64 returns
              method: 'POST', // change query method, default 'POST'
              name: 'imageFiles', // custom form name
              withCredentials: false, // withCredentials
              // personalize successful callback and call next function to insert new url to the editor
              callbackOK: (serverResponse, next) => {
                next(serverResponse.data.path);
              },
              // personalize failed callback
              callbackKO: serverError => {
                //alert(serverError);
                console.log(serverError)
              }
            },
            toolbar:[
              ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
              ['blockquote', 'code-block'],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{'header': [1, 2, 3, 4, 5, 6, false]}],
              [{'color': []}, {'background': []}],
              [{'font': []}],
              [{'align': []}],

              ['image']
            ]
          }
        }
      };
    },
    mounted(){
      if (this.id) {
        var uid = this.id;
        detailArticle({id:uid}).then(res => {
          console.log(res);
          this.form.title = res.data.title
          this.form.thumb_image = res.data.thumb_image
          this.form.image = res.data.image
          this.form.category_id = res.data.category_id
          this.form.content = res.data.content
        });
      }
      categoryList().then(res =>{

        let list = [];
        for(var i in res.items){
          list.push({
            label:res.items[i].name,
            value:res.items[i].uid
          });
        }
        this.options = list;
      });
    },
    methods:{
      uploadThumbImage(res, file) {
        var path = res.data.path;
        this.form.thumb_image = path;
      },
      uploadImage(res, file) {
        var path = res.data.path;
        this.form.image = path;
      },
      onUpdate(){
        this.form.id = this.id;
        console.log(this.form);
        updateArticle(this.form).then(res => {
          console.log(res);
          if(res.code == 0){
            this.$message({
              message: '修改成功！',
              type: 'success'
            });
            this.$router.push('/article');
          }
        }).catch(error => {});
      },
      onSubmit(){
        console.log(this.form);
        creatArticle(this.form).then(res => {
          if(res.code == 0){
            this.$message({
              message: '添加成功！',
              type: 'success'
            });
            this.$router.push('article');
          }
        }).catch(error => {});
      },
      // qill 回调事件
      onEditorBlur(quill) {
        console.log('editor blur!', quill)
      },
      onEditorFocus(quill) {
        console.log('editor focus!', quill)
      },
      onEditorReady(quill) {
        console.log('editor ready!', quill)
      },
      onEditorChange({ quill, html, text }) {
        console.log('editor change!', quill, html, text)
        this.content = html
      }
    }
  }
</script>

<style >
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>
